import { useEffect, useState } from "react";
import { ServiceData } from "../../../Services/Service";
import UserTables from "./UserTables";

  interface Listes{
    id:number,
    nom:string,
    firstname:string,
    magasin:string,
    email:string,
    roles:string[]
  }
  const UserList = () => {
    const[users,setUsers]=useState<Listes[]>([]);
    const[isLoading,setIsLoading]=useState<boolean>(true);
    const[error,setError]=useState<string|null>();

    useEffect( ()=>{
      const fetchList=async ()=>{
        try{
          const data=await ServiceData(`/api/admin/listUsers`,'GET');
          setUsers(data);
        }catch(err:any){
          setError(err.message)
        }finally{
          setIsLoading(false);
        }
      }
      fetchList();
    },[])    
        
    return (
    <div className="p-4">
      <div className="flex justify-content-between align-items-center text-center">        
        {isLoading && <p className="text-gray-500">Chargement...</p>}
        {error && <p className="text-red-500">{error}</p>}
      </div>

      {!isLoading && !error && users.length === 0 && (
        <p className="text-gray-500 text-center">Aucune liste trouvée pour ce tableau.</p>
      )}

      {!isLoading && users.length > 0 && (
        <UserTables users={users} />
      )}
    </div>
  );

};

export default UserList;
